/**
 * Button Configuration per Client
 *
 * This file defines client-specific button size variants.
 * Each client can override default button sizes with custom classes.
 */

export interface ButtonSizeConfig {
    default: string
    sm: string
    lg: string
    icon: string
    xl: string
}

/**
 * Default button sizes (used as fallback)
 */
const defaultButtonSizes: ButtonSizeConfig = {
    default: "h-9 px-4 py-2 has-[>svg]:px-3",
    sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
    lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
    icon: "size-9",
    xl: "h-13.5 px-4 py-2 text-lg",
}

/**
 * Client-specific button size configurations
 */
const clientButtonSizes: Record<string, Partial<ButtonSizeConfig>> = {
    migrosbank: {
        // Can add Migros Bank specific overrides here if needed
        // xl: "h-12 px-6 py-3 text-base",
    },
    // Add more clients here as needed
}

/**
 * Get button sizes for a specific client
 * Merges client-specific overrides with default sizes
 */
export function getButtonSizes(clientId: string): ButtonSizeConfig {
    const clientOverrides = clientButtonSizes[clientId] || {}
    return {
        ...defaultButtonSizes,
        ...clientOverrides,
    }
}
